<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="text-h5 mb-4">
                Добавление типа колонки биллинга
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-col cols="12 px-0">
                        <v-text-field v-model="name" label="Тип колонки" :rules="nameRules" required maxlength="30"
                            counter outlined class="mb-4" type="text" />
                    </v-col>
                    <v-card-actions class="px-0">
                        <v-spacer />
                        <v-btn type="submit" class="px-8" color="primary" :loading="submiting"
                            @click.prevent="submitForm">
                            Добавить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'AddBillingKind',
    data() {
        return {
            name: '',
            nameRules: [
                v => !!v || 'Тип обязателен',
                v => (v && v.length <= 20) || 'Тип должно содержать максимум 20 символов'
            ]
        }
    },
    methods: {
        async submitForm() {
            // Validate form
            if (!this.$refs.form.validate()) {
                return;
            }

            this.submiting = true;

            try {
                await this.axios.post('/billing/bill-column-vids', {
                    name: this.name
                });

                // Redirect after successful submission
                this.$router.push('/settings/billingVids');
            } catch (error) {
                console.error('Error:', error);
                alert('Произошла ошибка при сохранении');
            } finally {
                this.submiting = false;
            }
        }
    }
}
</script>